module.exports = __webpack_public_path__ + "img/pic-book.02f97ff.svg";